<template>
  <div class="nb-page">
    <div class="nb-tip">
      带 <span class="req">*</span> 为必填，缺失项请补充完善。点击"暂存"保存当前数据；点击"提交"后投保数据直接推送给出函机构审核。
    </div>
    <div
      class="nb-main"
      v-loading="loading"
    >
      <div class="plate-title">
        投保企业信息
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="170px"
        size="small"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="企业名称"
              prop="companyName"
            >
              <el-input v-model="form.companyName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码"
              prop="creditCode"
            >
              <el-input v-model="form.creditCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="法人姓名"
              prop="legalName"
            >
              <el-input v-model="form.legalName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="法人身份证号码"
              prop="legalCertNo"
            >
              <el-input v-model="form.legalCertNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="法人手机号码"
              prop="legalMobile"
            >
              <el-input v-model="form.legalMobile" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="企业地址"
              prop="companyAddress"
            >
              <el-input v-model="form.companyAddress" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="企业资质"
              prop="qualification"
            >
              <el-select
                v-model="qualificationList"
                multiple
                placeholder="请选择企业资质（可多选）"
                style="width: 100%"
              >
                <el-option
                  v-for="item in qualificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="营业执照"
              required
            >
              <file-box
                :files="filesByType['1']"
                :base-url="baseUrl"
                :applyno="applyno"
                file-type="1"
                @refresh="refreshFiles"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="法人身份证人像页"
              required
            >
              <file-box
                :files="filesByType['2']"
                :base-url="baseUrl"
                :applyno="applyno"
                file-type="2"
                @refresh="refreshFiles"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="法人身份证国徽页"
              required
            >
              <file-box
                :files="filesByType['3']"
                :base-url="baseUrl"
                :applyno="applyno"
                file-type="3"
                @refresh="refreshFiles"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="最高资质"
              prop="topQualification"
            >
              <el-input v-model="form.topQualification" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="经办人姓名"
              prop="contactName"
            >
              <el-input v-model="form.contactName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="经办人联系方式"
              prop="contactPhone"
            >
              <el-input v-model="form.contactPhone" />
            </el-form-item>
          </el-col>
        </el-row>

        <div
          class="plate-title"
          style="margin-top: 10px;"
        >
          项目信息
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目名称"
              prop="projectName"
            >
              <el-input v-model="form.projectName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目编号"
              prop="projectCode"
            >
              <el-input v-model="form.projectCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="标段名称"
              prop="sectionName"
            >
              <el-input v-model="form.sectionName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="标段编号"
              prop="sectionCode"
            >
              <el-input v-model="form.sectionCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="合同金额(元)"
              prop="contractAmount"
            >
              <el-input v-model="form.contractAmount" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="合同工期(天)"
              prop="contractPeriod"
            >
              <el-input v-model="form.contractPeriod" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="中标结果公告时间"
              prop="noticeTime"
            >
              <el-input
                v-model="form.noticeTime"
                placeholder="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="招标文件"
              required
            >
              <file-box
                :files="filesByType['4']"
                :base-url="baseUrl"
                :applyno="applyno"
                file-type="4"
                @refresh="refreshFiles"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="中标通知书"
              required
            >
              <file-box
                :files="filesByType['5']"
                :base-url="baseUrl"
                :applyno="applyno"
                file-type="5"
                @refresh="refreshFiles"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保函产品种类">
              <el-input
                :value="productName"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="担保金额(元)"
              prop="sumAmount"
            >
              <el-input v-model="form.sumAmount" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="担保期限(月)"
              prop="guaranteeMonths"
            >
              <el-input v-model="form.guaranteeMonths" />
            </el-form-item>
          </el-col>
        </el-row>

        <div
          class="plate-title"
          style="margin-top: 10px;"
        >
          受益人信息
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="受益人名称"
              prop="beneficiaryName"
            >
              <el-input v-model="form.beneficiaryName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="受益人统一社会信用代码"
              prop="beneficiaryCreditCode"
            >
              <el-input v-model="form.beneficiaryCreditCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="受益人注册地址"
              prop="beneficiaryAddress"
            >
              <el-input v-model="form.beneficiaryAddress" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="actions">
        <el-button
          @click="onSave"
          :loading="saving"
        >
          暂 存
        </el-button>
        <el-button
          type="primary"
          @click="onSubmit"
          :loading="submitting"
        >
          提 交
        </el-button>
        <div class="save-tip">
          投保数据直接推送给出函机构审核，状态变更为待审核
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { detail, save, submit, delFile } from '@/api/nonbid.js';
import { dictDetail } from '@/api/performance.js';

// 附件上传组件（el-upload 简装：单文件、上传成功后刷新详情）
const FileBox = {
  props: [ 'files', 'baseUrl', 'applyno', 'fileType' ],
  computed: {
    action() {
      return this.baseUrl + '/api/nonbid/apply/uploadFile';
    },
    current() {
      return (this.files || [])[0];
    },
  },
  methods: {
    del() {
      if (!this.current) return;
      delFile({ applyno: this.applyno, fileId: this.current.id }).then(() => this.$emit('refresh'));
    },
    preview() {
      window.open(this.baseUrl + '/api/nonbid/apply/readFile?applyno=' + this.applyno
        + '&source=' + encodeURIComponent(this.current.filePath));
    },
    onSuccess(res) {
      if (Number(res.status) === 200 || Number(res.code) === 200) {
        this.$emit('refresh');
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    onError() {
      this.$message.error('上传失败，请重试');
    },
  },
  render(h) {
    if (this.current) {
      return h('div', { class: 'file-card' }, [
        h('span', { class: 'name' }, this.current.fileName),
        h('span', [
          h('el-button', { props: { type: 'text', size: 'mini' }, on: { click: this.preview } }, [ '预览' ]),
          h('el-button', { props: { type: 'text', size: 'mini' }, on: { click: this.del } }, [ '删除' ]),
        ]),
      ]);
    }
    return h('el-upload', {
      props: {
        action: this.action,
        data: { applyno: this.applyno, fileType: this.fileType },
        showFileList: false,
        limit: 1,
        onSuccess: this.onSuccess,
        onError: this.onError,
      },
    }, [
      h('el-button', { props: { size: 'small', type: 'primary', plain: true } }, [ '点击上传' ]),
    ]);
  },
};

export default {
  components: { FileBox },
  data() {
    return {
      loading: false,
      saving: false,
      submitting: false,
      baseUrl: process.env.VUE_APP_FIRST_URL || '',
      applyno: this.$route.query.applyno || '',
      productName: '',
      orderId: null,
      files: [],
      qualificationList: [],
      qualificationOptions: [],
      form: {
        applyno: '',
        companyName: '', creditCode: '', legalName: '', legalCertNo: '', legalMobile: '', companyAddress: '',
        qualification: '', topQualification: '', contactName: '', contactPhone: '',
        projectName: '', projectCode: '', sectionName: '', sectionCode: '', sectionAddress: '',
        contractAmount: '', contractPeriod: '', noticeTime: '', sumAmount: '', guaranteeMonths: '',
        beneficiaryName: '', beneficiaryCreditCode: '', beneficiaryAddress: '',
      },
      rules: {
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        creditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        legalName: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        legalCertNo: [{ required: true, message: '请输入法人身份证号码', trigger: 'blur' }],
        legalMobile: [{ required: true, message: '请输入法人手机号码', trigger: 'blur' }],
        qualification: [{ required: true, message: '请选择企业资质', trigger: 'change' }],
        contactName: [{ required: true, message: '请输入经办人姓名', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入经办人联系方式', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        sumAmount: [{ required: true, message: '请输入担保金额', trigger: 'blur' }],
        guaranteeMonths: [{ required: true, message: '请输入担保期限', trigger: 'blur' }],
      },
    };
  },
  watch: {
    // 多选数组与提交字段同步，保证 form-item 校验实时生效
    qualificationList(val) {
      this.form.qualification = (val || []).join(',');
    },
  },
  computed: {
    filesByType() {
      const map = {};
      (this.files || []).forEach(f => {
        map[f.fileType] = map[f.fileType] || [];
        map[f.fileType].push(f);
      });
      return map;
    },
  },
  created() {
    if (!this.applyno) {
      this.$message.error('缺少申请流水号');
      return;
    }
    this.form.applyno = this.applyno;
    this.loadDict();
    this.loadDetail();
  },
  methods: {
    loadDict() {
      dictDetail({ dictName: 'nonbidQualification' }).then(({ data }) => {
        this.qualificationOptions = data.data || [];
      });
    },
    loadDetail() {
      this.fetchDetail(true);
    },
    // 上传/删除附件后仅刷新附件列表，不回写表单，避免冲掉未暂存的填写内容
    refreshFiles() {
      this.fetchDetail(false);
    },
    fetchDetail(echoForm) {
      if (echoForm) {
        this.loading = true;
      }
      detail({ applyno: this.applyno }).then(({ data }) => {
        const res = data.data || {};
        const order = res.order || {};
        this.orderId = order.id;
        this.files = res.files || [];
        if (!echoForm) {
          return;
        }
        this.productName = res.productName || '';
        // 回显（只覆盖接口返回的非空字段，避免覆盖暂存输入）
        Object.keys(this.form).forEach(k => {
          if (order[k] !== null && order[k] !== undefined) {
            this.form[k] = String(order[k]);
          }
        });
        this.qualificationList = order.qualification ? String(order.qualification).split(',') : [];
      }).finally(() => {
        this.loading = false;
      });
    },
    buildPayload() {
      return { applyno: this.applyno, ...this.form, qualification: this.qualificationList.join(',') };
    },
    onSave() {
      this.saving = true;
      save(this.buildPayload()).then(({ data }) => {
        if (Number(data.status) === 200 || Number(data.code) === 200) {
          this.$message.success('暂存成功');
          this.loadDetail();
        } else {
          this.$message.error(data.message || '暂存失败');
        }
      }).finally(() => {
        this.saving = false;
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        // 附件必填校验：营业执照/法人身份证人像页/国徽页/招标文件/中标通知书
        const needFiles = [
          [ '1', '营业执照' ],
          [ '2', '法人身份证人像页' ],
          [ '3', '法人身份证国徽页' ],
          [ '4', '招标文件' ],
          [ '5', '中标通知书' ],
        ];
        const missing = needFiles
          .filter(([ t ]) => !(this.filesByType[t] && this.filesByType[t].length))
          .map(([ , n ]) => n);
        if (missing.length) {
          this.$message.error('请先上传：' + missing.join('、'));
          return;
        }
        this.submitting = true;
        submit(this.buildPayload()).then(({ data }) => {
          if (Number(data.status) === 200 || Number(data.code) === 200) {
            this.$message.success('提交成功，已推送出函机构审核');
            this.$router.push('/nonbid/detail?orderCode=' + (this.orderCode || this.applyno));
          } else {
            this.$message.error(data.message || '提交失败');
          }
        }).finally(() => {
          this.submitting = false;
        });
      });
    },
  },
};
</script>

<style scoped>
.nb-page { background: #fff; min-height: 100vh; }
.nb-header { display: flex; justify-content: space-between; align-items: center; padding: 10px 40px; border-bottom: 1px solid #eee; }
.nb-logo { font-size: 20px; font-weight: bold; color: #333; }
.nb-phone { font-size: 14px; color: #0E52D4; }
.nb-tip { background: #f0f8ff; border: 1px solid #d0e6ff; border-radius: 4px; margin: 14px 40px; padding: 10px 16px; font-size: 13px; color: #1372BF; line-height: 1.9; }
.nb-main { margin: 0 40px 40px; }
.plate-title { font-size: 17px; font-weight: bold; color: #000; padding-left: 12px; margin: 12px 0 16px; position: relative; }
.plate-title::before { content: " "; position: absolute; left: 0; top: 50%; margin-top: -8px; width: 4px; height: 16px; background: #0E52D4; border-radius: 2px; }
.req { color: #f5222d; margin-right: 3px; }
.actions { text-align: center; margin: 40px 0 20px; }
.save-tip { color: #999; font-size: 12px; margin-top: 10px; }
.file-card { display: flex; justify-content: space-between; align-items: center; background: #f0f8ff; border-radius: 4px; padding: 6px 12px; font-size: 13px; }
</style>
